import { Result } from '@/generic/functional';
import { FileType } from '@/rules-management/domain/FileType.ts';

const ALLOWED_MIME_TYPES = [
  'application/json',
  'text/markdown',
  'application/xml',
  'application/yaml',
  'text/plain',
] as const;

const ALLOWED_MIME_TYPES_SET: Set<string> = new Set(ALLOWED_MIME_TYPES);

type AllowedMimeType = (typeof ALLOWED_MIME_TYPES)[number];

const isAllowedMimeType = (mime: string): mime is AllowedMimeType =>
  ALLOWED_MIME_TYPES_SET.has(mime);

const mimeToType = (mime: AllowedMimeType): FileType => {
  switch (mime) {
    case 'application/json':
      return FileType.JSON;
    case 'text/markdown':
      return FileType.MARKDOWN;
    case 'application/xml':
      return FileType.XML;
    case 'application/yaml':
      return FileType.YAML;
    case 'text/plain':
      return FileType.PLAIN_TEXT;
  }
};

export class InvalidMimeTypeError extends Error {
  constructor(readonly mime: string) {
    super(`Invalid mime type: ${mime}`);
    this.name = 'InvalidMimeTypeError';
  }
}

export class RulesFileToImport {
  private constructor(
    readonly file: File,
    readonly type: FileType,
  ) {}

  static of(file: File): Result<InvalidMimeTypeError, RulesFileToImport> {
    if (isAllowedMimeType(file.type)) {
      return Result.success(new RulesFileToImport(file, mimeToType(file.type)));
    }
    return Result.error(new InvalidMimeTypeError(file.type));
  }
}
